import { render, staticRenderFns } from "./ContactUser.vue?vue&type=template&id=28001ac0"
import script from "./ContactUser.vue?vue&type=script&lang=js"
export * from "./ContactUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports